import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const endPoint = '/motorista/'

const importarCSV = async ({ dataForm }, page, pathRetorno, paramAuth0Conn) => {
  axios
    .post(
      process.env.URL_API_BASE + endPoint + 'upload-motorista-admin',
      dataForm,
      config
    )
    .then(() => {
      page.$parent.$parent.$data.showModalLoader = false
      page.$refs.files.value = ''
      page.$notification.success('Arquivo importado com sucesso !', {
        timer: 10,
        position: 'bottomRight'
      })
    })
    .catch(error => {
      page.$parent.$parent.$data.showModalLoader = false
      let mensagem = 'Erro ao importar arquivos.'

      if (error.response.data.error !== null) {
        mensagem = error.response.data.error === 'token_expired'
          ? 'A sua sessão expirou! Faça login novamente.'
          : error.response.data.error
      }

      page.$notification.error(mensagem, {
        timer: 10,
        position: 'bottomRight'
      })
    })
}

const cadastrarMotoristaAdmin = async (
  {
    nome,
    email,
    cpf,
    tel_celular,
    end_cep,
    end_logradouro,
    end_numero,
    end_complemento,
    end_bairro,
    end_cidade,
    end_uf,
    end_pais
  },
  page,
  pathRetorno,
  paramAuth0Conn
) => {
  axios
    .post(
      process.env.URL_API_BASE + endPoint + 'motorista-admin',
    {
      nome: nome,
      email: email,
      cpf: cpf,
      tel_celular: tel_celular,
      end_cep: end_cep,
      end_logradouro: end_logradouro,
      end_numero: end_numero,
      end_complemento: end_complemento,
      end_bairro: end_bairro,
      end_cidade: end_cidade,
      end_uf: end_uf,
      end_pais: end_pais
    },
      config
    )
    .then(() =>
      page.$notification.success('Motorista inserido com sucesso !', {
        timer: 10,
        position: 'bottomRight'
      })
    )
    .catch(error => {
      let mensagem = 'Erro ao cadastrar motorista !'
      if (error.response && error.response.data.code) {
        mensagem = error.response.data.error
      } else {
        console.log(error.message)
        mensagem = 'Ocorreu um erro ao gravar o registro.'
      }
      page.$parent.$parent.$data.showModalLoader = false
      page.$notification.error(mensagem, {
        timer: 10,
        position: 'bottomRight'
      })
    })
}

const cadastrarMotorista = ({
  nome,
  email,
  cpf,
  tel_celular,
  end_cep,
  end_logradouro,
  end_numero,
  end_complemento,
  end_bairro,
  end_cidade,
  end_uf,
  end_pais,
  end_latitude,
  end_longitude
}) => {
  return axios.post(
    process.env.URL_API_BASE + endPoint,
    {
      nome: nome,
      email: email,
      cpf: cpf,
      tel_celular: tel_celular,
      end_cep: end_cep,
      end_logradouro: end_logradouro,
      end_numero: end_numero,
      end_complemento: end_complemento,
      end_bairro: end_bairro,
      end_cidade: end_cidade,
      end_uf: end_uf,
      end_pais: end_pais,
      end_latitude: end_latitude,
      end_longitude: end_longitude
    },
    config
  )
}

const alterarMotorista = ({
  id,
  nome,
  email,
  cpf,
  tel_celular,
  end_cep,
  end_logradouro,
  end_numero,
  end_complemento,
  end_bairro,
  end_cidade,
  end_uf,
  end_pais,
  end_latitude,
  end_longitude,
  idc_status,
  idc_termo_aceito,
  genero,
  observacao,
  primeiro_acesso,
  aceita_receber_whatsapp
}) => {
  return axios.patch(
    process.env.URL_API_BASE + endPoint + id,
    {
      nome,
      email,
      cpf,
      tel_celular,
      end_cep,
      end_logradouro,
      end_numero,
      end_complemento,
      end_bairro,
      end_cidade,
      end_uf,
      end_pais,
      end_latitude,
      end_longitude,
      idc_status,
      idc_termo_aceito,
      genero,
      observacao,
      primeiro_acesso,
      aceita_receber_whatsapp
    },
    config
  )
}

const inserirMotoristaComplemento = ({
  cd_motorista,
  cd_veiculo_fabricante,
  veiculo_modelo,
  veiculo_ano,
  veiculo_placa,
  encosto_cabeca,
  idc_motorista_kovi,
  idc_veiculo_proprio,
  posse_veiculo
}) => {
  return axios.post(
    `${process.env.URL_API_BASE}/motorista-complemento`,
    {
      cd_motorista,
      cd_veiculo_fabricante,
      veiculo_modelo,
      veiculo_ano,
      veiculo_placa,
      encosto_cabeca,
      idc_motorista_kovi: idc_motorista_kovi !== '' ? idc_motorista_kovi : null,
      idc_veiculo_proprio: idc_veiculo_proprio !== '' ? idc_veiculo_proprio : null,
      posse_veiculo: posse_veiculo !== '' ? posse_veiculo : null
    },
    config
  )
}

const alterarStatusEmLote = async (ids, status) => {
  let response = await axios.patch(
    process.env.URL_API_BASE + endPoint + 'alterar-status-lote/' + ids,
    { idc_status: status },
    config
  )
  return response.data
}

const preAprovarMotorista = async id => {
  let response = await axios.patch(
    process.env.URL_API_BASE + endPoint + 'pre-aprovar/' + id,
    {},
    config
  )
  return response.data
}

const aprovarMotorista = async id => {
  let response = await axios.patch(
    process.env.URL_API_BASE + endPoint + 'aprovar/' + id,
    {},
    config
  )
  return response.data
}

const reprovarMotorista = async id => {
  let response = await axios.patch(
    process.env.URL_API_BASE + endPoint + 'reprovar/' + id,
    {},
    config
  )
  return response.data
}

const alterarParaPendenciaMotorista = async id => {
  let response = await axios.patch(
    process.env.URL_API_BASE + endPoint + 'alterar-para-pendencia/' + id,
    {},
    config
  )
  return response.data
}

const listarMotoristas = async status => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      endPoint +
      (status !== null && status !== undefined
        ? 'listar-por-status/' + status
        : ''),
    config
  )
  return response.data
}

const obterMotorista = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + endPoint + id,
    config
  )
  return response.data
}

const verificarEmailEmUso = async (email, id = null) => {
  let response = await axios.get(
    process.env.URL_API_BASE + endPoint + 'verificar-email-utilizado/' + email,
    config
  )
  return (
    response.data.existe &&
    (id === null || !response.data.cd_motorista.includes(id))
  )
}

const obterMotoristaComplemento = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/motorista-complemento/' + id,
    config
  )
  return response.data
}

const alterarMotoristaComplemento = ({
  id,
  cd_veiculo_fabricante,
  veiculo_modelo,
  veiculo_ano,
  veiculo_placa,
  encosto_cabeca,
  idc_motorista_kovi,
  idc_veiculo_proprio,
  posse_veiculo
}) => {
  return axios.patch(
    `${process.env.URL_API_BASE}/motorista-complemento/${id}`,
    {
      cd_veiculo_fabricante,
      veiculo_modelo,
      veiculo_ano,
      veiculo_placa,
      encosto_cabeca,
      idc_motorista_kovi: idc_motorista_kovi !== '' ? idc_motorista_kovi : null,
      idc_veiculo_proprio: idc_veiculo_proprio !== '' ? idc_veiculo_proprio : null,
      posse_veiculo: posse_veiculo !== '' ? posse_veiculo : null
    },
    config
  )
}

const desativarMotoristaEquipamento = (id, equipamento, status, ponto) => {
  return axios.patch(
    process.env.URL_API_BASE +
      '/motorista-equipamento/desativar/' +
      id +
      '/' +
      equipamento,
    {
      idc_status: status,
      cd_ponto_apoio: ponto
    },
    config
  )
}

const vincularMotoristaEquipamento = (id, player) => {
  return axios.post(
    process.env.URL_API_BASE + '/motorista-equipamento/vincular-player',
    {
      cd_motorista: id,
      cd_player: player
    },
    config
  )
}

const pesquisarCep = cep => {
  return axios.get(
    process.env.URL_API_BASE + endPoint + 'cep/' + cep,
    config
  )
    .then(response => response.data)
}

const listarMotoristasComFiltroPorNome = (filtro) => {
  return axios.get(
      `${process.env.URL_API_BASE}${endPoint}?filter_field=nome&filter=${filtro}`,
      config
    )
    .then(response => response.data)
}

const listar = (url) => {
  return axios
    .get(url, config)
    .then(response => response.data)
}

const gerarUrlTokenAceiteTermos = (id) => {
  return axios
    .get(`${process.env.URL_API_BASE}${endPoint}/gerar-url-aceite-termos/${id}`, config)
    .then(response => response.data)
}

export default {
  cadastrarMotorista,
  alterarMotorista,
  inserirMotoristaComplemento,
  preAprovarMotorista,
  aprovarMotorista,
  reprovarMotorista,
  alterarParaPendenciaMotorista,
  listarMotoristas,
  obterMotorista,
  verificarEmailEmUso,
  obterMotoristaComplemento,
  alterarMotoristaComplemento,
  pesquisarCep,
  alterarStatusEmLote,
  desativarMotoristaEquipamento,
  vincularMotoristaEquipamento,
  cadastrarMotoristaAdmin,
  importarCSV,
  listarMotoristasComFiltroPorNome,
  listar,
  gerarUrlTokenAceiteTermos
}



// WEBPACK FOOTER //
// ./src/actions/MotoristaActions.js